import React from 'react';
import { 
  Card, 
  Button, 
  List, 
  Typography, 
  Space, 
  Tooltip, 
  Badge,
  Upload
} from 'antd';
import { 
  PaperClipOutlined, 
  UploadOutlined, 
  DownloadOutlined, 
  DeleteOutlined 
} from '@ant-design/icons';
import { formatFileSize, getFileType } from '../utils';
import { UPLOAD_CONFIG } from '../constants';

const { Text } = Typography;

const FileUploader = ({
  attachments = [],
  onFileUpload,
  onRemoveFile,
  style = {}
}) => {
  const uploadProps = {
    ...UPLOAD_CONFIG,
    onChange: onFileUpload,
  };

  return (
    <Card
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <PaperClipOutlined />
          <span>File Attachments</span>
          {attachments.length > 0 && (
            <Badge 
              count={attachments.length} 
              style={{ 
                marginLeft: '8px',
                background: '#fa8c16'
              }} 
            />
          )}
        </div>
      }
      style={{ marginBottom: '24px', ...style }}
      bodyStyle={{ padding: '16px' }}
    >
      <Upload {...uploadProps}>
        <Button 
          icon={<UploadOutlined />} 
          size="middle" 
          style={{ 
            borderRadius: '6px', 
            marginBottom: attachments.length > 0 ? '16px' : '0' 
          }}
        >
          Upload Files
        </Button>
      </Upload>

      {attachments.length > 0 && (
        <div style={{ marginTop: '12px' }}>
          <Text strong style={{ fontSize: '14px', display: 'block', marginBottom: '12px' }}>
            Attached Files ({attachments.length})
          </Text>
          <List
            size="small"
            dataSource={attachments}
            renderItem={file => (
              <List.Item
                actions={[
                  <Tooltip title="Download">
                    <Button 
                      type="text" 
                      icon={<DownloadOutlined />}
                      size="small"
                    />
                  </Tooltip>,
                  <Button 
                    type="text" 
                    danger 
                    size="small" 
                    icon={<DeleteOutlined />}
                    onClick={() => onRemoveFile(file.id)}
                  />
                ]}
                style={{
                  border: '1px solid #f0f0f0',
                  borderRadius: '6px',
                  marginBottom: '8px',
                  padding: '12px'
                }}
              >
                <List.Item.Meta
                  avatar={<PaperClipOutlined style={{ color: '#1890ff', fontSize: '18px' }} />}
                  title={
                    <Text style={{ fontSize: '13px', fontWeight: '500' }}>{file.name}</Text>
                  }
                  description={
                    <Text type="secondary" style={{ fontSize: '11px' }}>
                      {file.size} • {getFileType(file.name)} • {file.uploadDate}
                    </Text>
                  }
                />
              </List.Item>
            )}
          />
        </div>
      )}

      {attachments.length === 0 && (
        <div style={{ 
          textAlign: 'center', 
          padding: '20px',
          color: '#bfbfbf'
        }}>
          <PaperClipOutlined style={{ fontSize: '32px', marginBottom: '8px', opacity: 0.5 }} />
          <div style={{ fontSize: '14px', color: '#8c8c8c' }}>
            No files attached
          </div>
          <Text type="secondary" style={{ fontSize: '12px' }}>
            Upload relevant documents, images, or files
          </Text>
        </div>
      )}
    </Card>
  );
};

export default FileUploader;
